import { PatientUpdateContactDataCommand } from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { Choice } from '@dreryk/watermelon';

import { PatientContactDataUpdateFormBean } from './PatientContactDataUpdateForm.types';

type PatientContactDataUpdateActionRenderProps = {
   updatePatientContactData: (formData: PatientContactDataUpdateFormBean) => Promise<void>;
};

type PatientContactDataUpdateActionProps = Readonly<{
   patientId: number;
   children: (renderProps: PatientContactDataUpdateActionRenderProps) => JSX.Element;
   onSuccess: VoidFunction;
}>;

export const PatientContactDataUpdateAction = (props: PatientContactDataUpdateActionProps): JSX.Element => {
   const { executeAsync: updatePatientContactData } = useCqrsCommand<void, PatientContactDataUpdateFormBean>(
      (parameters) => {
         const command = new PatientUpdateContactDataCommand();

         command.id = props.patientId;
         command.emailAddress = Choice.withUseDefaultIfNull(parameters.emailAddress);
         command.phoneNumber = Choice.withUseDefaultIfNull(parameters.phoneNumber);

         return command;
      },
      { onSuccess: props.onSuccess }
   );

   return props.children({ updatePatientContactData: updatePatientContactData });
};
